import React, { useEffect, useState } from 'react';
import { Sheet } from './Dialog';
import './FieldHelpTooltip.css';

const MOBILE_QUERY = '(max-width: 768px)';

/**
 * 입력 필드 옆 "?" 도움말.
 * - 데스크톱: 호버/포커스 시 말풍선 툴팁
 * - 모바일(≤768px): 탭하면 바텀시트(Sheet 프리미티브 — 스크림·핸들·ESC·포커스 처리 포함)
 */
const FieldHelpTooltip = ({ title, items = [], ariaLabel = '도움말 보기', variant = 'default' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;

    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const handleChange = () => {
      const nextIsMobile = mediaQuery.matches;
      setIsMobile(nextIsMobile);
      if (!nextIsMobile) setIsOpen(false);
    };

    handleChange();
    mediaQuery.addEventListener?.('change', handleChange);
    return () => mediaQuery.removeEventListener?.('change', handleChange);
  }, []);

  const closeSheet = () => setIsOpen(false);
  const toggleMobileSheet = () => {
    if (isMobile) {
      setIsOpen((prev) => !prev);
    }
  };

  return (
    <span className={`wq-field-help wq-field-help--${variant}`} onClick={(event) => event.stopPropagation()}>
      <button
        type="button"
        className="wq-field-help__trigger"
        aria-label={ariaLabel}
        aria-expanded={isMobile ? isOpen : undefined}
        aria-haspopup={isMobile ? 'dialog' : undefined}
        onClick={(event) => {
          event.stopPropagation();
          toggleMobileSheet();
        }}
      >
        ?
      </button>
      {!isMobile && (
        <span className="wq-field-help__tooltip" role="tooltip">
          {title && <strong>{title}</strong>}
          {items.map((item, index) => (
            <span key={`${item}-${index}`}>{item}</span>
          ))}
        </span>
      )}
      {isMobile && (
        <Sheet
          dragHandle
          onClose={closeSheet}
          open={isOpen}
          size="sm"
          testId="field-help-sheet"
          title={title || '도움말'}
        >
          <div className="wq-field-help__sheet-body">
            {items.map((item, index) => (
              <p key={`${item}-${index}`}>{item}</p>
            ))}
          </div>
        </Sheet>
      )}
    </span>
  );
};

export default FieldHelpTooltip;
